import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from "vue";
import Fingerprint2 from "fingerprintjs2";
export default {
  __name: 'App',
  setup(__props) {
    const CUR_VERSION = require("../package.json").version;
    onMounted(() => {
      document.body.style.setProperty("--el-color-primary", "#0059FF");
      document.body.style.setProperty("--el-color-primary-light-3", "rgb(77, 139, 255)");
      console.warn("~生产环境：", CUR_VERSION);
      Fingerprint2.get(components => {
        // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        const values = components.map(component => component.value); // 配置的值的数组
        const murmur = Fingerprint2.x64hash128(values.join(""), 31); // 生成浏览器指纹
        localStorage.setItem("browserId", murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};